export const CREATE_ADHOC_ROOM =
  "VIDYO_CONNECTOR::ADHOC_ROOM::CREATE_ADHOC_ROOM";
export const CREATE_ADHOC_ROOM_SUCCEEDED =
  "VIDYO_CONNECTOR::ADHOC_ROOM::CREATE_ADHOC_ROOM_SUCCEEDED";
export const CREATE_ADHOC_ROOM_FAILED =
  "VIDYO_CONNECTOR::ADHOC_ROOM::CREATE_ADHOC_ROOM_FAILED";
